import { role } from './utils';
import { createContext, Dispatch } from 'react';
import { IDepartmentList, IListItem } from './type';

interface ISelectedMap {
    [key: string]: IListItem;
}
interface IUplevelIdMap {
    [key: string]: string;
}
interface IExcludeMap {
    [key: string]: string;
}
export interface IPageInfo {
    count: number;
    currentPage: number;
    totalPage: number;
    size: number;
}

export interface IUplevelDepartment {
    [key: string]: IListItem;
}

export interface IDepartmentCache {
    currDepartmentId: string;
    currDepartmentName: string;
    upLevelDepartmentId: string;
    parents: IDepartmentList[];
    children: IDepartmentList[];
    manage_permission?: number;
}
export interface IDialogStates {
    role: any;
    departmentCache: IDepartmentCache; // 当前部门信息缓存
    uplevelDepartment: IUplevelDepartment; // 所有可管理部门列表及其父部门列表
    uplevelIdMap: IUplevelIdMap; // 部门数结构，只是有管理权限的部门树
    enterpriseName: string;
    dataList: IListItem[]; // 待选区列表
    departmentDataList: IListItem[]; // 待选区部门列表
    memberDataList: IListItem[]; // 待选区部门成员列表
    selectedList: IListItem[];
    selectedMap: ISelectedMap; // 已选中的map
    selectedDepartmentMap: Map<string, IListItem>;
    selectedMemberMap: Map<string, IListItem>;
    excludeMap: IExcludeMap; // 已选中的默认不显示的数据
    searchList: IListItem[];
    isSearchMode: boolean;
    pageInfo: IPageInfo;
    ts: number;
}
export enum DIALOG_ACTION_TYPE {
    SET_DATALIST = 1, // 设置待选列表数据
    UPDATE_DATA_SELECTED = 2, // 选中或者移除选中
    SET_DATASUG = 3, // 搜索结果列表
    SET_CACHE = 4, // 当前部门信息、企业名称缓存
    SET_DEFAULT_SELECTED_LIST = 5, // 默认选择的部门列表
    SET_DEFAULT_SELECTED_DATAINFO = 6,
    SET_UPLEVEL_DEPARTMENT = 7, // 所有访问权限的部门列表和部门树。
    SET_ALL_LIST_CHECKED = 8, // 全选或取消动作
    CLEAN = 100,
    SET_DEPARTMENTLIST = 9,
    SET_MEMBERLIST = 10,
    UPDATE_SELECTED = 11, // 筛选
    CLEAN_SELECTED_LIST = 12,
    CLEAN_DATA_LIST = 13,
    SET_SELECTED_LIST = 14,
    SET_MEMBER_SELECTED_MAP = 15,
    SET_DEPARTMENT_SELECTED_MAP = 16,
    SET_IS_SEARCH_MODE = 17,
    CLEAN_SELECTED = 18
}
export interface IDialogAction {
    type: DIALOG_ACTION_TYPE;
    payload: any;
}
export interface IDialogProps {
    state: IDialogStates;
    dispatch: Dispatch<IDialogAction>;
}

export const initState: IDialogStates = {
    role: role,
    enterpriseName: '',
    uplevelDepartment: {},
    uplevelIdMap: {},
    departmentCache: {
        currDepartmentId: '0',
        currDepartmentName: '',
        upLevelDepartmentId: '-1',
        parents: [],
        children: [],
    },
    dataList: [],
    departmentDataList: [],
    memberDataList: [],
    selectedList: [],
    searchList: [],
    ts: 0,
    pageInfo: {
        count: 0,
        currentPage: 1,
        totalPage: 1,
        size: 500,
    },
    isSearchMode: false,
    selectedMap: {},
    selectedDepartmentMap: new Map(),
    selectedMemberMap: new Map(),
    excludeMap: {},
};
export const DialogContext = createContext<IDialogProps>({} as IDialogProps);
